import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { useAuth } from '@/lib'
import { useEffect } from 'react';
import { auth } from '@/lib/better-auth';

export const Route = createFileRoute('/_app/dashboard')({
    beforeLoad: async ({ context, location }) => {
        console.log('Dashboard beforeLoad - Checking session via Better Auth');

        // Since this is under _app, the parent route already handles auth
        // Additional guard for direct navigation
        const session = context.auth.data
        console.log("🚀 ~ session:", session)
        // if (!session) {
        //     throw redirect({
        //         to: '/login',
        //         search: {
        //             redirect: location.href,
        //         },
        //     });
        // }
    },
    component: RouteComponent,
})

function RouteComponent() {
    const { isAuthenticated, isLoading, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        // Wait for auth to finish loading
        if (isLoading) return;

        // If not authenticated, redirect to login
        if (!isAuthenticated) {
            console.log('User not authenticated, redirecting to login');
            navigate({ to: '/login' });
            return;
        }

        console.log('User authenticated:', user);
    }, [isAuthenticated, isLoading, navigate, user]);

    // Show loading while checking authentication
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
                    <p className="mt-2 text-gray-600">Loading...</p>
                </div>
            </div>
        );
    }

    // Show nothing while redirecting (if not authenticated)
    if (!isAuthenticated) {
        return null;
    }

    // Show dashboard content for authenticated users
    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Dashboard</h1>
            <p>Welcome back, {user?.fullName || user?.email}!</p>

        </div>
    );
}
